import React from 'react'

const ArrowIcon = () => {
  return (
    <svg className='arrow-icon'>
        <path d="M1.322 1l5 5-5 5" stroke="currentColor" strokeWidth="2" fill="none" fillRule="evenodd"/>
    </svg>
  )
}

export default ArrowIcon